module.exports = __webpack_public_path__ + "static/media/avatar-3.b1b571fd.jpg";